// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3ZNfw","text":"e376O","button":"_1fc_Z","textButton":"_3VSW-","iconButton":"_3j4Zu","animated":"_2VgkC","verticalAlign":"_36hf_"};